export default __webpack_public_path__ + "static/media/mobile-tip-computer.ab5c8c14.png";